import TOKEN from '../constants';

export default () => process.env.NODE_ENV === 'development';

export const getToken = () => localStorage.getItem(TOKEN);

export const setToken = (token) => {
  localStorage.setItem(TOKEN, token);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN);
};
